import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, View, Text } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';
import FreeText from './FreeText';

const styles = StyleSheet.create({
  container: {
    paddingTop: 15,
  },
  button: {
    width: 42,
    height: 42,
    borderRadius: 10,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 4,
  },
  row: {
    alignSelf: 'center',
  },
  firstRowLabel: {
    marginLeft: 4,
    color: '#FF4C4D',
    textAlign: 'left',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  secondRowLabel: {
    marginRight: 4,
    color: '#0DC98B',
    textAlign: 'right',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  },
  itemContainer: {
    flexDirection: 'row',
    marginVertical: 4,
  },
  npsNumber: {
    fontSize: 16,
    fontFamily: FONT_STYLE.BOLD
  }
});

const NPSItem = ({
  color,
  point,
  selectedPoint,
}: {
  color: string;
  point: number;
  selectedPoint: number;
}) => {
  const selected = selectedPoint === point;
  return (
    <View
      style={[
        styles.button,
        {
          borderColor: color,
          backgroundColor: selected ? color : '#FFFFFF',
        },
      ]}>
      <Text style={[styles.npsNumber, { color: selected ? '#FFFFFF' : color }]}>{point}</Text>
    </View>
  );
};

type NPSProps = {
  onSelect?: (point: number, reason: string) => void;
  defaultAnswer?: any;
  isCustom?: boolean;
  followUpQuestion?: string;
  startText?: string;
  endText?: string;
};

const NPS = ({ onSelect, defaultAnswer = null, isCustom = false, followUpQuestion = '', startText = "", endText = "" }) => {
  const [selectedPoint, setSelect] = useState(-1)
  const [isOtherChoice, setVisibleTextInput] = useState(false)
  const [otherReason, setOtherReason] = useState('')

  // Đảm bảo defaultAnswer luôn là object có values
  const safeDefaultAnswer = defaultAnswer && defaultAnswer.values ? defaultAnswer : { values: [] };
  const safeStartText = startText || "";
  const safeEndText = endText || "";
  const safeFollowUpQuestion = followUpQuestion || '';

  const handlePress = (point: number) => {
    setVisibleTextInput(isCustom)
    if (onSelect) {
      onSelect(point, otherReason);
    }
    setSelect(point);
  };

  const onChangeText = (text) => {
    setOtherReason(text);
    if (onSelect) {
      onSelect(selectedPoint, text);
    }
  }

  useEffect(() => {
    if (safeDefaultAnswer && safeDefaultAnswer.values && safeDefaultAnswer.values.length > 0) {
      let valueNum = Number.parseInt(safeDefaultAnswer.values[0]);
      setSelect(valueNum);
    }
  }, [safeDefaultAnswer])

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={styles.firstRowLabel}>{safeStartText}</Text>
        <View style={styles.itemContainer}>
          {Array.from({ length: 7 }, (_, i) => i).map(item => {
            return (
              <TouchableOpacity
                key={item}
                onPress={() => handlePress(item)}>
                <NPSItem
                  point={item}
                  color={'#FF4C4D'}
                  selectedPoint={selectedPoint}
                />
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.itemContainer}>
          {Array.from({ length: 4 }, (_, i) => i + 7).map(item => {
            return (
              <TouchableOpacity
                key={item}
                onPress={() => handlePress(item)}>
                <NPSItem
                  key={item}
                  point={item}
                  color={
                    item < 9 ? '#F7CC15' : '#0DC98B'
                  }
                  selectedPoint={selectedPoint}
                />
              </TouchableOpacity>
            );
          })}
        </View>
        <Text style={styles.secondRowLabel}>{safeEndText}</Text>
      </View>
      {
        isOtherChoice ? (
          <View>
            <Text style={{ fontFamily: FONT_STYLE.BOLD, fontSize: 14, marginTop: 15 }}>{safeFollowUpQuestion && safeFollowUpQuestion.length ? safeFollowUpQuestion : 'Bạn có thể cho biết lý do không ?'}</Text>
            <FreeText handleText={onChangeText} />
          </View>
        ) : null
      }
    </View>
  );
};

export default NPS;
